<svelte:options
  customElement={{
    tag: "oc-card-v2",
    /*                       */
    extend: window.__components.extend(),
    props: {
      asButton: { type: "Boolean", attribute: "as-button" },
      base64Href: { type: "String", attribute: "base64-href" },
      backgroundColor: { type: "String", attribute: "background-color" },
      elevationLevel: { type: "String", attribute: "elevation-level" },
      inverted: { type: "Boolean" },
      href: { type: "String" },
      ocAriaLabel: { type: "String", attribute: "oc-aria-label" },
      rel: { type: "String" },
      target: { type: "String" },
      size: { type: "String" },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./CardV2.types.js";
  import BasicCardV2 from "../../../common/components/Card/BasicCardV2.svelte";
  import DefaultStyles from "../../../common/components/DefaultStyles/DefaultStyles.svelte";

  let {
    href = undefined,
    base64Href = undefined,
    asButton = false,
    backgroundColor = undefined,
    elevationLevel = "canvas",
    inverted = false,
    ocAriaLabel = undefined,
    rel = undefined,
    target = undefined,
    size = "100",
  }: Props = $props();

  const Host = $host<HTMLElement>();
</script>

<BasicCardV2
  {Host}
  {asButton}
  bind:href
  {base64Href}
  {ocAriaLabel}
  {rel}
  {target}
  {elevationLevel}
  {size}
  {backgroundColor}
  {inverted}
>
  {#snippet children(onslotchange)}
    <slot name="primary-action" {onslotchange} />
    <slot />
  {/snippet}
</BasicCardV2>

<DefaultStyles />

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";
  :global {
    :host {
      display: flex; /*                                   */
      position: relative;

      /*        */
      --background-color: initial;
    }
  }
</style>
